export default __webpack_public_path__ + "locales/el-GR/InviteDialog.json?hash=6b3e76be584e34a1ade6c21a929c5d2b";